import { request } from "common";

/**
 * 根据字典类型获取字典数据公用方法
 * @param {*} dicType 字典类型,支持String,Array
 * @param {*} dataTag 字典标签
 * @param {*} isNumber 字典value数据类型，不传默认String,传值转Number
 * @param {*} dicData 本地字典对象
 */
export function getDicDataList(dictType, dataTag, isNumber, dicData = {}) {
  return new Promise((resolve) => {
    let defaultMap = {}; //根据dictType获取的本地字典对象
    let netArr = []; //需调用字典接口获取的dicType数组
    let typeArr = typeof dictType == "string" ? [dictType] : dictType;
    typeArr.forEach((el) => {
      if (dicData[el]) {
        defaultMap[el] = dicData[el];
      } else {
        netArr.push(el);
      }
    });
    if (netArr.length > 0) {
      getDictData({ dictType: netArr.join(","), dataTag: dataTag })
        .then((res) => {
          let data = [];
          if (res.code === "00000" && res.data) {
            data = res.data;
            for (let key in data) {
              data[key].forEach((item) => {
                item.value =
                  isNumber && !isNaN(parseInt(item.dataValue))
                    ? parseInt(item.dataValue)
                    : item.dataValue;
                item.label = item.dataTag;
              });
            }
            resolve({ ...defaultMap, ...data });
          }
        })
        .catch(() => {
          resolve(defaultMap);
        });
    } else {
      resolve(defaultMap);
    }
  });
}
/**
 * 根据字典类型获取字典数据
 */
export function getDictData(params) {
  return request({
    url: "/portal/api/v1/appCommon/listDictDetail",
    method: "get",
    params: params,
  });
}
/**
 * 获取参数配置详情
 * @param {*} keyName 字典类型,支持String,Array
 */
export function getParamdata(keyName) {
  return new Promise((resolve) => {
    let typeArr = typeof keyName == "string" ? [keyName] : keyName;
    request({
      url: "/portal/api/v1/appCommon/paramdata",
      method: "get",
      params: { keyNames: typeArr.join(",") },
    }).then((res) => {
      let data = [];
      if (res.code === "00000" && res.data) {
        data = res.data;
        resolve(data);
      }
    });
  });
}
/**
 * 获取基础数据详情列表(异步查询)
 * @param {*} keyName 字典类型,支持String,Array
 */
export function getlistBasicDataDetail(basicDataUuid ='8d88e5b6f114466ca12a56c85307d578', parentUuid) {
  return new Promise((resolve) => {
    request({
      url: "/portal/api/v1/appCommon/listBasicDataDetail",
      method: "get",
      params: { basicDataUuid: basicDataUuid,parentUuid:parentUuid},
    }).then((res) => {
      let data = [];
      if (res.code === "00000" && res.data) {
        data = res.data;
        resolve(data);
      }
    });
  });
}
